import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const modeAnalytics = defineConnector({
  identifier: "modeAnalytics",
  name: "Mode Analytics",
  tagLine: "Collaborative analytics platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://app\\.mode\\.com/api.*",
  auth: (app) =>
    basicAuth({
      username: app.config.workspaceToken,
      password: app.secret.workspaceSecret,
    }),
  steps: [
    {
      title: "Create a Mode workspace API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Mode, go to **Workspace Settings → Privacy & Security → API** and create a workspace API token. Copy the token, secret, and workspace username.",
        },
      ],
    },
    {
      title: "Enter your Mode details",
      items: [
        {
          kind: "input",
          label: "Workspace token",
          required: true,
          target: { kind: "configuration", field: "workspaceToken" },
        },
        {
          kind: "input",
          label: "Workspace secret",
          required: true,
          target: { kind: "secrets", field: "workspaceSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://app.mode.com/api/account",
      expectedStatus: [200, 403],
    }),
  },
});
